export function formatTextStyle(text: string): string {
  const regexBold = /\*(.*?)\*/g;
  const regexItalic = /_(.*?)_/g;
  const regexMarked = /~(.*?)~/g;
  const regexURL = /(https?:\/\/[^\s]+)/g;

  text = text.replace(
    regexURL,
    '<a class="whitespace-normal break-words break-all text-primary-600 underline" href="$1" target="_blank">$1</a>',
  );
  text = text.replace(regexBold, '<strong>$1</strong>');
  text = text.replace(regexItalic, '<em>$1</em>');
  text = text.replace(regexMarked, '<del>$1</del>');

  return text;
}
